import { useEffect, useRef } from 'react';

import Button from 'components/_parts/atoms/button';
import Label from 'components/_parts/atoms/label';

import { PopUpComType } from 'components/types/parts/popUp';

function Index({
  isHide,
  setIsHide,
  datas,
  className,
  style,
  position,
  type,
  setModal,
  setTypeModal,
  setChoose,
  competencyPart,
  ...props
}: PopUpComType) {
  const clickOut = useRef(null);

  useEffect(() => {
    function handleClickOutside(e: { [key: string]: string }) {
      if (clickOut.current && !(clickOut?.current as { contains: (e: string) => {} })?.contains(e.target)) {
        setIsHide(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside as unknown as EventListenerObject);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside as unknown as EventListenerObject);
    };
  }, [clickOut]);
  return (
    <div
      id="popUpBusinessProcess"
      ref={clickOut}
      className={`${position !== undefined ? position : 'custom_option_search'
        } ${isHide && 'show'} ${className}`}
    >
      {datas !== undefined && type === 'search' ? (
        <div className="layout_item_search scroll_custom_search">
          {datas?.map((val, index) => (
            <div
              id='list-window-search'
              key={index + 1}
              className="custom_item search_item"
              style={{ ...style, cursor: 'pointer' }}
              onClick={() => {
                setIsHide(false);
                if (competencyPart) {
                  setChoose(competencyPart, val);
                } else {
                  setChoose(val);
                }
              }}
            >
              <Label>{val?.label}</Label>
              <Button
                style={{
                  backgroundColor:
                    val.type === 'primary'
                      ? '#2E9CFF'
                      : val.type === 'steering'
                        ? '#79FF39'
                        : val.type === 'support'
                          ? '#FFDF32'
                          : 'transparent',
                  height: '24px',
                  padding: '0px 20px',
                  fontWeight: '600',
                }}
              >
                {val?.type}
              </Button>
            </div>
          ))}
        </div>
      ) : (
        <div className="d-flex justify-content-center">Belum ada data</div>
      )}
    </div>
  );
}

export default Index;
